import { useEffect } from 'react';
import { captureErrorInApm } from '../../../lib/apm/utils/captureErrorInApm.util';
import { logOfflineOrder } from '../../../services/modules/orders/orders.repository';
import { ArrayUtil } from '../../../utils/array.utils';
import { useNetworkContext } from '../contexts/network/network.context';
import { useUserHasOfflineDatabase } from '../database/offlineDatabase/hooks/useUserHasOfflineDatabase';
import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { offlineOrdersRepository } from '../repositories/offlineOrders.repository';
import { OfflineOrderTransformers } from '../transformers/OfflineOrder.transformers';

const NUMBER_OF_ORDERS_TO_SEND_AT_ONCE = 10;

export const useLogOfflineOrders = () => {
  const { isForcingOfflineMode } = useNetworkContext();
  const userHasOfflineDatabase = useUserHasOfflineDatabase();

  const validateIfCanLog = () => {
    if (isForcingOfflineMode || !userHasOfflineDatabase || !offlineDatabase) {
      return false;
    }

    return true;
  };

  const logOfflineOrders = async () => {
    const canLog = validateIfCanLog();
    if (!canLog) {
      return;
    }

    try {
      const allOfflineOrders = await offlineOrdersRepository.getAll();

      const needLog = allOfflineOrders.length > 0;

      if (!needLog) {
        return;
      }

      const ordersToLog = allOfflineOrders.map(
        OfflineOrderTransformers.toSendOfflineOrderToSyncInput,
      );

      const chunckedOrders = ArrayUtil.chunk(ordersToLog, NUMBER_OF_ORDERS_TO_SEND_AT_ONCE);

      for (const orders of chunckedOrders) {
        await Promise.all(
          orders.map(async (order) => {
            const logRes = await logOfflineOrder(order);

            if (!logRes.ok) {
              captureErrorInApm.offlineError(logRes.originalError);
            }
          }),
        );
      }
    } catch (error) {
      console.error('logOfflineOrder', { error });
    }
  };

  useEffect(() => {
    logOfflineOrders();
  }, [userHasOfflineDatabase, offlineDatabase]);
};
